import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import workCallTransitions from "@/work/call/mixins/workCallTransitions";
import relps from "@/data/forms/mixins/relps.js";
import generateLog from "@/document/log/mixins/generateLog.js";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "getDetailChar",
      "getMaintCall",
      "getUser",
      "getDetailRelps"
    ])
  },
  // eslint-disable-next-line
  mixins: [
    generateID,
    generateForms,
    transFunctions,
    workCallTransitions,
    numberFunctions,
    generateLog,
    relps
  ],
  data() {
    return {
      tempAction: null
    };
  },
  methods: {
    generateWorkCallRelps() {
      let relps = this.formRelpsWorkCall;
      relps.e5 = this.getDetailRelps.e5; // technical results
      relps.l5 = this.getDetailRelps.l5; // order parts
      relps.h5 = this.getDetailRelps.h5; // human resources
      relps.o5 = this.getDetailRelps.o5; // permit request
      relps.s1 = this.getDetailRelps.s1; // hazards
      relps.s3 = this.getDetailRelps.s3; // barriers
      relps.s4 = this.getDetailRelps.s4; // controls
      relps.s5 = this.getDetailRelps.s5; // outcomes
      relps.w5 = this.getDetailRelps.w5; // tasks list
      return relps;
    },
    generateWorkCallDocument(maintCall, index, asset) {
      // help

      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "W2";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");
      // const ind = index + 1;

      // console.log("");
      // console.log(">>> GENERATE WORK CALL <<<");
      // console.log("MAINT CALL: ");
      // console.log(maintCall);
      // console.log("CALL TITLE : " + maintCall.basic.title);
      // console.log("INDEX      : " + ind);
      // console.log("ASSET: ");
      // console.log(asset);

      // GENERATE form
      let work = this.generateWorkCallForm(); // form is from compnew component

      // ASSIGN data
      work.basic.did = did;
      work.basic.idg = idg;
      work.basic.tag = tag;
      work.basic.act = true; // set to true
      work.basic.title = maintCall.basic.title;
      let id = this.generateIDfromMaster(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg,
        this.getDetailStats.nm7
      );
      work.basic.id = id;

      // CHAR Data
      work.char.type = this.getDetail.char.types; // type of work call;
      work.char.scope = this.getDetail.char.call;
      work.char.risk = this.getDetail.char.risk;
      work.char.shift = this.getDetail.char.shift;
      work.char.escal = this.getDetail.char.escal;
      work.char.pri = this.getDetail.char.pri;
      work.char.comp = this.getDetail.char.comp;
      work.char.theme = this.getDetail.strategy.char.type;
      work.char.dis = this.getDetail.strategy.char.dis;
      work.char.driver = this.getDetail.strategy.char.driver;
      work.char.shift = this.getDetail.char.shift;
      work.char.risk = this.getDetail.char.risk;
      work.char.key = this.getDetail.char.key;
      work.char.batch = this.getDetail.char.batch;
      work.char.oeng = this.getDetail.char.oeng;
      work.char.oexe = this.getDetail.char.oexe;
      work.char.ores = this.getDetail.char.ores;
      work.char.oplan = this.getDetail.char.oplan;
      work.char.oops = this.getDetail.char.oops;
      work.char.impact = this.getDetail.char.impact; // impact description
      work.char.isoc = this.getDetail.char.isoc; // impact socail
      work.char.ienv = this.getDetail.char.ienv; // impact envirnment
      work.char.ibus = this.getDetail.char.ibus; // impact business
      work.char.ihse = this.getDetail.char.ihse; // impact hse
      work.char.irep = this.getDetail.char.irep; // impact reputtaion
      work.char.ifin = this.getDetail.char.ifin; // impact finace / asset

      // STATS
      work.stats.dcrt = maintCall.stats.dcrt;
      work.stats.dplan = maintCall.stats.dplan;
      work.stats.ddue = maintCall.stats.ddue;
      work.stats.no5 = maintCall.stats.no5; // permit
      work.stats.nl5 = maintCall.stats.nl5; // parts
      work.stats.ne5 = maintCall.stats.ne5; // procedure
      work.stats.nw5 = maintCall.stats.nw5; // work procedure
      work.stats.nh5 = maintCall.stats.nh5; // peopel resources
      // LINK
      work.link = this.getDetailLink;

      // APPEND ASSET
      work.link.atag = asset.tag;
      work.link.adid = asset.did; // asset
      work.link.aid = asset.id;
      work.link.aidg = asset.idg;
      work.link.at = asset.title;
      work.link.asys = "";
      work.link.aunit = "";
      work.link.amap = "";
      work.link.agrid = "";

      // UPDATE getAssetDID (this is needed to Asset Log);
      this.$store.dispatch("changeAssetDID", asset.did);

      // APPEND MAINT CALL (not working)
      // work.link.mcdid = maintCall.basic.did; // asset
      // work.link.mcid = maintCall.basic.id;
      // work.link.mcidg = maintCall.basic.idg;
      // work.link.mct = maintCall.basic.title;
      // REV
      work.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let type = "B";
      let status = this.getDetail.char.status;
      work.trans = this.generateWorkCallTransitions(status, type);

      // COPY RELPS
      // work.relps.parts = this.getDetail.relps.parts;
      // work.relps.permit = this.getDetail.relps.permit;
      // work.relps.resr = this.getDetail.relps.resr;
      // work.relps.tasks = this.getDetail.relps.tasks;

      // GENERATE ASSET LOG;
      console.log("");
      console.log("ASSET LOG FOR WORK CALL");
      this.generateAssetLog(work, "was created.");

      // HELP
      console.log("NEW WORK CALL");
      console.log(work);
      console.log(asset);

      return work;
    }
  }
};
